
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_l0dv0_1wron_93",
  "header": "awsui_header_l0dv0_1wron_108",
  "header-link": "awsui_header-link_l0dv0_1wron_119",
  "header-link--has-logo": "awsui_header-link--has-logo_l0dv0_1wron_129",
  "header-link-text": "awsui_header-link-text_l0dv0_1wron_129",
  "header-logo": "awsui_header-logo_l0dv0_1wron_134",
  "header-logo--stretched": "awsui_header-logo--stretched_l0dv0_1wron_140",
  "list-container": "awsui_list-container_l0dv0_1wron_145",
  "list": "awsui_list_l0dv0_1wron_145",
  "list-variant-root": "awsui_list-variant-root_l0dv0_1wron_155",
  "list-variant-root--last": "awsui_list-variant-root--last_l0dv0_1wron_159",
  "list-variant-expandable-link-group": "awsui_list-variant-expandable-link-group_l0dv0_1wron_163",
  "list-item": "awsui_list-item_l0dv0_1wron_167",
  "section": "awsui_section_l0dv0_1wron_173",
  "expandable-link-group": "awsui_expandable-link-group_l0dv0_1wron_174",
  "section--no-ident": "awsui_section--no-ident_l0dv0_1wron_177",
  "expandable-link-group--no-ident": "awsui_expandable-link-group--no-ident_l0dv0_1wron_178",
  "refresh": "awsui_refresh_l0dv0_1wron_187",
  "list-variant-section-group": "awsui_list-variant-section-group_l0dv0_1wron_195",
  "section-group": "awsui_section-group_l0dv0_1wron_200",
  "section-group-title": "awsui_section-group-title_l0dv0_1wron_210",
  "link": "awsui_link_l0dv0_1wron_214",
  "link-active": "awsui_link-active_l0dv0_1wron_223",
  "info": "awsui_info_l0dv0_1wron_257",
  "external-icon": "awsui_external-icon_l0dv0_1wron_261",
  "divider": "awsui_divider_l0dv0_1wron_265",
  "divider-default": "awsui_divider-default_l0dv0_1wron_270",
  "divider-header": "awsui_divider-header_l0dv0_1wron_274"
};
  